import React, { useEffect, useState } from "react";
import HomeCard from "./HomeCard";
import "./Home.css";
import ChartBox from "./ChartBox";
import PieChartsBox from "./PieChartsBox";
import IncomeCards from "./IncomeCards";
import Transaction from "./Transaction";
import Revenue from "./Revenue";
import DonutChart from "./DonutChart";
import DashboardService from "../../Services/DashboardService";
import HomeService, { getProfile } from "../../Services/HomeService";
import {
  calculateProfitAmount,
  compareProfitByAmount,
  compareSale,
} from "../../utils/Helper";
import toast from "react-hot-toast";
import moment from "moment";

const Index = () => {
  const [profile, setProfile] = useState({});
  const fetchProfile = async () => {
    try {
      // setFetchLoading(true);
      const res = await getProfile();
      console.log("profile", res?.data);
      if (res?.status) {
        setProfile(res?.data);
        // setFetchLoading(false);
      } else {
        toast.error("Error while Fetching Course Fees Data");
        // setFetchLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch profile");
      console.error("Error fetching Profile details:", error);
      // setFetchLoading(false);
    }
  };
  useEffect(() => {
    fetchProfile();
  }, []);
  return (
    <div
      className="main_wrap"
      style={{
        fontFamily: "sans-serif",
        backgroundColor: "#f5f7fb",
        padding: "20px",
      }}
    >
      {/* Top Profile Card */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="https://randomuser.me/api/portraits/women/1.jpg"
            alt="profile"
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              marginRight: "15px",
            }}
          />
          <div>
            {/* <div style={{ fontSize: "14px", color: "gray" }}>
              Welcome to Stoke Dashboard
            </div> */}
            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
              {profile?.name}
            </div>
            {/* <div style={{ fontSize: "14px", color: "gray" }}>
              UI / UX Designer
            </div> */}
          </div>
        </div>
        {/* <div style={{ display: "flex", gap: "40px", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: "14px", color: "gray" }}>
              Recent Projects
            </div>
            <div style={{ fontWeight: "bold" }}>20</div>
          </div>
          <div>
            <div style={{ fontSize: "14px", color: "gray" }}>
              Completed Projects
            </div>
            <div style={{ fontWeight: "bold" }}>15</div>
          </div>
          <div>
            <div style={{ fontSize: "14px", color: "gray" }}>
              Total Earnings
            </div>
            <div style={{ fontWeight: "bold" }}>5000</div>
          </div>
          <button
            style={{
              padding: "8px 20px",
              backgroundColor: "#6c63ff",
              color: "white",
              border: "none",
              borderRadius: "6px",
            }}
          >
            Setting
          </button>
        </div> */}
      </div>

      {/* Middle Cards */}
      <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
        <div
          style={{
            flex: 1,
            backgroundColor: "#e8ecfd",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h4>Welcome Back !</h4>
          {/* <p style={{ color: "gray" }}>Skote Saas Dashboard</p>
          <p style={{ color: "gray" }}>
            7 + Layouts
            <br />
            24/7 Support
          </p> */}
        </div>
        <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h4>Total Colleges</h4>
          {/* <div style={{ fontWeight: "bold", fontSize: "20px" }}>
            1,452 <span style={{ color: "green", fontSize: "14px" }}>+48%</span>
          </div>
          <p style={{ color: "gray", fontSize: "14px" }}>
            From previous period
          </p> */}
        </div>
        <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h4>Total Courses</h4>
          {/* <div style={{ fontWeight: "bold", fontSize: "20px" }}>
            3,522 <span style={{ color: "green", fontSize: "14px" }}>+48%</span>
          </div>
          <p style={{ color: "gray", fontSize: "14px" }}>
            From previous period
          </p> */}
        </div>
        <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h4>Total Users</h4>
          {/* <div style={{ fontWeight: "bold", fontSize: "20px" }}>
            5,547 <span style={{ color: "green", fontSize: "14px" }}>+48%</span>
          </div>
          <p style={{ color: "gray", fontSize: "14px" }}>
            From previous period
          </p> */}
        </div>
      </div>

      {/* Earning & Chart Placeholder */}
      <div style={{ display: "flex", gap: "20px" }}>
        {/* <div
          style={{
            flex: 2,
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <h4>Earning</h4>
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>2453.35</div>
          <div style={{ color: "green", fontSize: "14px" }}>
            + 0.2% From previous period
          </div>
          <button
            style={{
              marginTop: "10px",
              padding: "8px 15px",
              backgroundColor: "#5865f2",
              color: "white",
              border: "none",
              borderRadius: "6px",
            }}
          >
            View Details
          </button>
          <div style={{ marginTop: "10px", color: "gray" }}>
            Last month
            <br />
            <strong>2281.04</strong>
          </div>
          <div
            style={{
              marginTop: "20px",
              backgroundColor: "#f5f5f5",
              height: "200px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "gray",
            }}
          >
            [Chart Placeholder]
          </div>
        </div> */}

        {/* Sales Analytics */}
        {/* <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <h4>Sales Analytics</h4>
          <div
            style={{
              height: "200px",
              borderRadius: "50%",
              backgroundColor: "#f5f5f5",
              margin: "20px 0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "gray",
            }}
          >
            [Pie Chart Placeholder]
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <span style={{ color: "#6c63ff" }}>Product A</span>
            <span style={{ color: "#36b37e" }}>Product B</span>
            <span style={{ color: "#ff5c75" }}>Product C</span>
          </div>
        </div> */}
      </div>
    </div>
  );
  //   const userRole = localStorage.getItem("role");
  //   const userCity = localStorage.getItem("city");
  //   const loggedUserID = localStorage.getItem("uid");
  //   const [cities, setCities] = useState([]);
  //   const [selectedCity, setSelectedCity] = useState(userCity || "");
  //   const [filterData, setFilterData] = useState({});
  //   const [loading, setLoading] = useState(false);
  //   // Fetch cities
  //   // const fetchCities = async () => {
  //   //     try {
  //   //         const res = await HomeService.getCities();
  //   //         console.log("HYT31", res.data);
  //   //         if (res?.data) {
  //   //             setCities(res.data);
  //   //             if (userCity) {
  //   //                 setCities([res.data.find(item => item._id === userCity)])
  //   //             }
  //   //         }
  //   //     } catch (error) {
  //   //         console.error("Error fetching cities:", error);
  //   //     }
  //   // }
  //   useEffect(() => {}, []);
  //   //Donut PIE Chart
  //   const [donutData, setDonutData] = useState([]);
  //   //API 1
  //   const fetchDonutData = async () => {
  //     setLoading(true);
  //     const data = {
  //       ...(selectedCity && { city: selectedCity }),
  //       ...(selectedYear && { year: selectedYear }),
  //       ...(selectedMonth && { month: selectedMonth }),
  //     };
  //     try {
  //       const res = await DashboardService.getDonutChartData(data);
  //       if (res?.success) {
  //         let data = res.data;
  //         console.log("UYT52", data);
  //         setDonutData([
  //           { name: "Sales", amount: data.totalSales },
  //           { name: "Expenses", amount: data.totalExpense },
  //           { name: "Profit", amount: data.totalSales - res.data.totalExpense },
  //         ]);
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching cities:", error);
  //     }
  //   };
  //   //Revenue
  //   const monthShortNames = {
  //     January: "Jan",
  //     February: "Feb",
  //     March: "Mar",
  //     April: "Apr",
  //     May: "May",
  //     June: "Jun",
  //     July: "Jul",
  //     August: "Aug",
  //     September: "Sep",
  //     October: "Oct",
  //     November: "Nov",
  //     December: "Dec",
  //   };
  //   const [revenueData, setRevenueData] = useState([]);
  //   const [revenueSalesData, setRevenueSalesData] = useState([]);
  //   //API 2
  //   const fetchRevenueData = async () => {
  //     const data = {
  //       ...(selectedCity && { city: selectedCity }),
  //       ...(selectedYear && { year: selectedYear }),
  //     };
  //     try {
  //       const res = await DashboardService.getRevenueChartData(data);
  //       if (res?.success) {
  //         console.log("TTR89", res?.data);
  //         setRevenueData(
  //           res?.data.map(({ month, totalSales, totalExpense }) => ({
  //             month: monthShortNames[month],
  //             Sales: totalSales,
  //             Expenses: totalExpense,
  //           }))
  //         );
  //         setRevenueSalesData([
  //           [
  //             "Element",
  //             "Sales(₹) ",
  //             { role: "style" },
  //             { role: "annotation", type: "string" },
  //           ],
  //           ...res?.data.map((item, index) => [
  //             item.month,
  //             item.totalSales, // Keep this as a number
  //             "rgb(172, 221, 54)",
  //             // `₹ ${item.totalSales.toLocaleString("en-IN")}`, // Add Rupee symbol in the annotation column
  //             item.month,
  //           ]),
  //         ]);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   //Compare
  //   const [compareMonthsData, setCompareMonthsData] = useState([]);
  //   const [compareSaleByAmount, setCompareSaleByAmount] = useState({});
  //   const [compareExpensesByAmount, setCompareExpensesByAmount] = useState({});
  //   const [compareSaleByCount, setCompareSaleByCount] = useState({});
  //   const [profit, setProfit] = useState({});
  //   const [compareProfit, setCompareProfit] = useState({});
  //   //API /total-past-two-month-view
  //   const fetchCompareData = async () => {
  //     const data = {
  //       ...(selectedCity && { city: selectedCity }),
  //       ...(selectedYear && { year: selectedYear }),
  //       ...(selectedMonth && { month: selectedMonth }),
  //     };
  //     try {
  //       const res = await DashboardService.getCompareData(data);
  //       if (res?.success) {
  //         console.log("YT124", res?.data);
  //         setCompareMonthsData(res?.data);
  //         setProfit(calculateProfitAmount(res?.data));
  //         setCompareProfit(compareProfitByAmount(res?.data));
  //         setCompareSaleByAmount(compareSale(res?.data, "totalSales"));
  //         setCompareExpensesByAmount(compareSale(res?.data, "totalExpense"));
  //         setCompareSaleByCount(compareSale(res?.data, "totalSalesDataCount"));
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   //Sales transactions
  //   const initialSaleTransactions = [
  //     {
  //       _id: "67c9baf558f73208514632cc",
  //       price: 5000,
  //       date: "2025-03-19T00:00:00.000Z",
  //       city: [
  //         {
  //           _id: "67938940a1d10a99391c00cd",
  //           name: "Pune",
  //           image:
  //             "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/8dadad70-dfbc-11ef-9df4-61d1a402725e.jpg",
  //         },
  //       ],
  //       saleType: "Community",
  //     },
  //     {
  //       _id: "67ca8c2ed932b6a6d566d6ec",
  //       price: 2000,
  //       date: "2025-03-12T00:00:00.000Z",
  //       city: [
  //         {
  //           _id: "677f77afcef85861517f11b9",
  //           name: "Delhi",
  //           image:
  //             "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/ffad4070-d4b8-11ef-bea8-0de93b285811.jpg",
  //         },
  //       ],
  //       saleType: "Subscription",
  //     },
  //     {
  //       _id: "67ca8e5a80692a056307f8e6",
  //       price: 2500,
  //       date: "2025-03-11T00:00:00.000Z",
  //       city: [
  //         {
  //           _id: "677f77afcef85861517f11b9",
  //           name: "Delhi",
  //           image:
  //             "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/ffad4070-d4b8-11ef-bea8-0de93b285811.jpg",
  //         },
  //       ],
  //       saleType: "Subscription",
  //     },
  //     {
  //       _id: "67ca8fd480692a056307f9f4",
  //       date: "2025-03-07T00:00:00.000Z",
  //       price: 1000,
  //       city: [
  //         {
  //           _id: "677f77afcef85861517f11b9",
  //           name: "Delhi",
  //           image:
  //             "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/ffad4070-d4b8-11ef-bea8-0de93b285811.jpg",
  //         },
  //       ],
  //       saleType: "Advertisement",
  //     },
  //     {
  //       _id: "67ca909a80692a056307fa8f",
  //       price: 450,
  //       date: "2025-03-06T00:00:00.000Z",
  //       city: [
  //         {
  //           _id: "677f77afcef85861517f11b9",
  //           name: "Delhi",
  //           image:
  //             "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/ffad4070-d4b8-11ef-bea8-0de93b285811.jpg",
  //         },
  //       ],
  //       saleType: "Community",
  //     },
  //     {
  //       _id: "67ca907080692a056307fa6b",
  //       price: 500,
  //       date: "2025-03-04T00:00:00.000Z",
  //       city: [
  //         {
  //           _id: "677f77afcef85861517f11b9",
  //           name: "Delhi",
  //           image:
  //             "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/ffad4070-d4b8-11ef-bea8-0de93b285811.jpg",
  //         },
  //       ],
  //       saleType: "Society",
  //     },
  //     {
  //       _id: "67b5befa3c3e27da7333e936",
  //       price: 2000,
  //       date: "2025-03-02T00:00:00.000Z",
  //       city: [
  //         {
  //           _id: "677d837505a75f9997831bfe",
  //           name: "Kolkata",
  //           image:
  //             "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/089d75b0-d4b9-11ef-bea8-0de93b285811.jpg",
  //         },
  //       ],
  //       saleType: "Inventory",
  //     },
  //   ];
  //   const [salesTransactionData, setSalesTransactionData] = useState([]);
  //   //API 4
  //   const fetchSalesTransactionData = async () => {
  //     const data = {
  //       ...(selectedCity && { city: selectedCity }),
  //       ...(selectedYear && { year: selectedYear }),
  //       ...(selectedMonth && { month: selectedMonth }),
  //     };
  //     try {
  //       const res = await DashboardService.getSalesTransactionData(data);
  //       if (res?.success) {
  //         setSalesTransactionData(res?.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   const [months, setMonths] = useState([
  //     { id: 1, name: "January" },
  //     { id: 2, name: "February" },
  //     { id: 3, name: "March" },
  //     { id: 4, name: "April" },
  //     { id: 5, name: "May" },
  //     { id: 6, name: "June" },
  //     { id: 7, name: "July" },
  //     { id: 8, name: "August" },
  //     { id: 9, name: "September" },
  //     { id: 10, name: "October" },
  //     { id: 11, name: "November" },
  //     { id: 12, name: "December" },
  //   ]);
  //   // const [selectedMonth, setSelectedMonth] = useState(moment().subtract(1, "months").format("MMMM"))
  //   const [selectedMonth, setSelectedMonth] = useState(moment().format("MMMM"));
  //   const currentYear = new Date().getFullYear();
  //   const years = Array.from({ length: 10 }, (_, index) => ({
  //     id: index,
  //     name: currentYear - 9 + index,
  //   }));
  //   const [selectedYear, setSelectedYear] = useState(moment().format("YYYY"));
  //   // const [selectedYear, setSelectedYear] = useState()
  //   useEffect(() => {
  //     if ((selectedYear && !selectedMonth) || (!selectedYear && selectedMonth)) {
  //       toast.error("Please select both Year and Month!");
  //       return;
  //     }
  //     // fetchCities();
  //     fetchDonutData();
  //     fetchRevenueData();
  //     fetchCompareData();
  //     fetchSalesTransactionData();
  //   }, [selectedCity, selectedYear, selectedMonth]);
  //   return (
  //     <>
  //       <div className="main_wrap">
  //         <div className="dash_board_wrapper">
  //           <div className="left_dashboard_div">
  //             <div className="left_dashboard_head_wrapper">
  //               <div>
  //                 <h2 className="dashboard_head">Dashboard</h2>
  //                 <h4 className="dahsboard_head_para">
  //                   An any way to manage sales with care and passion
  //                 </h4>
  //               </div>
  //               <div
  //                 style={{
  //                   display: "flex",
  //                   justifyContent: "flex-end",
  //                   columnGap: "10px",
  //                 }}
  //               >
  //                 <div className="date_input_wrapper">
  //                   <i class="fa-solid fa-city"></i>
  //                   {/* <p className='date_para'>January 2024-May 2024 </p> */}
  //                   <select
  //                     className="_form-control _date_para"
  //                     style={{
  //                       border: "0",
  //                       background: "transparent",
  //                     }}
  //                     value={selectedCity}
  //                     onChange={(e) => {
  //                       setSelectedCity(e.target.value);
  //                     }}
  //                   >
  //                     <option value="" disabled={userCity}>
  //                       All City
  //                     </option>
  //                     {cities.map((city, key) => (
  //                       <option key={key} value={city._id}>
  //                         {city.name}
  //                       </option>
  //                     ))}
  //                   </select>
  //                   {/* <i class="fa-solid fa-angle-down angle"></i> */}
  //                 </div>
  //                 <div className="date_input_wrapper">
  //                   <i class="fa-solid fa-calendar"></i>
  //                   {/* <p className='date_para'>January 2024-May 2024 </p> */}
  //                   <select
  //                     className="_form-control _date_para"
  //                     style={{
  //                       border: "0",
  //                       background: "transparent",
  //                     }}
  //                     value={selectedMonth}
  //                     onChange={(e) => {
  //                       setSelectedMonth(e.target.value);
  //                     }}
  //                   >
  //                     <option value="">Month</option>
  //                     {months.map((item, index) => (
  //                       <option key={index} value={item.name}>
  //                         {item.name}
  //                       </option>
  //                     ))}
  //                   </select>
  //                   <select
  //                     className="_form-control _date_para"
  //                     style={{
  //                       border: "0",
  //                       background: "transparent",
  //                     }}
  //                     value={selectedYear}
  //                     onChange={(e) => {
  //                       setSelectedYear(e.target.value);
  //                     }}
  //                   >
  //                     <option value="">Year</option>
  //                     {years.map((item, index) => (
  //                       <option key={index} value={item.name}>
  //                         {item.name}
  //                       </option>
  //                     ))}
  //                   </select>
  //                   {/* <i class="fa-solid fa-angle-down angle"></i> */}
  //                 </div>
  //               </div>
  //             </div>
  //             <div className="card_wrapper_home">
  //               <IncomeCards
  //                 compareSalesByCount={compareSaleByCount}
  //                 compareSaleByAmount={compareSaleByAmount}
  //                 compareExpensesByAmount={compareExpensesByAmount}
  //                 totalSaleAmountOfLastMonth={
  //                   compareMonthsData[0]?.totalSales || 0
  //                 }
  //                 totalExpensesAmountOfLastMonth={
  //                   compareMonthsData[0]?.totalExpense || 0
  //                 }
  //               />
  //             </div>
  //             <div className="transaction_revenue_wrapper">
  //               <Transaction data={salesTransactionData} />
  //               <Revenue
  //                 data={revenueData}
  //                 sales={revenueSalesData}
  //                 profit={profit}
  //                 compareProfit={compareProfit}
  //               />
  //             </div>
  //           </div>
  //           <div className="right_dashboard_div">
  //             <div className="total_view_performance_div">
  //               <h1>Total View Performance</h1>
  //               <div className="donut_chart_div">
  //                 <DonutChart data={donutData} loading={loading} />
  //               </div>
  //               {/* <p className='here_para'>Here are some tips on how to <br/> improve your score.</p>
  //                        <div className='button_wrapper_guide'>
  //                        <button className='guide_btn'>Guide Views</button>
  //                        </div> */}
  //               <div
  //                 className="net_income_head_wrapper donut-data-wrapper"
  //                 style={{
  //                   paddingBottom: "17px",
  //                 }}
  //               >
  //                 <div
  //                   className="income_expenses_wrapper"
  //                   style={{
  //                     display: "flex",
  //                     justifyContent: "center",
  //                     marginTop: "20px",
  //                   }}
  //                 >
  //                   <div className="expenses_div_wrapper">
  //                     <div
  //                       className="expenses_div565"
  //                       style={{
  //                         background: "rgb(56, 121, 103)",
  //                       }}
  //                     ></div>
  //                     <p
  //                       style={{
  //                         fontSize: "9px",
  //                       }}
  //                     >
  //                       Total Sales
  //                     </p>
  //                   </div>
  //                   <div className="expenses_div_wrapper">
  //                     <div
  //                       className="expenses_div565"
  //                       style={{
  //                         background: "rgb(245, 165, 66)",
  //                       }}
  //                     ></div>
  //                     <p
  //                       style={{
  //                         fontSize: "9px",
  //                       }}
  //                     >
  //                       Total Expenses
  //                     </p>
  //                   </div>
  //                   <div className="income_div_wrapper">
  //                     <div
  //                       className="income_div565"
  //                       style={{
  //                         background: "rgb(171, 220, 50)",
  //                       }}
  //                     ></div>
  //                     <p
  //                       style={{
  //                         fontSize: "9px",
  //                       }}
  //                     >
  //                       Net Profit
  //                     </p>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //             <div className="level_up_wrapper">
  //               <h3>Level up your sales managing to the next level.</h3>
  //               <p>An any way to manage saes with care and precision</p>
  //               <button>Update to Winners</button>
  //             </div>
  //           </div>
  //           {/* <HomeCard /> */}
  //           {/* <div className='row mt-2'>
  //                         <div className='col-md-7 col-12'>
  //                             <ChartBox />
  //                         </div>
  //                         <div className='col-md-5 col-12'>
  //                             <PieChartsBox />
  //                         </div>
  //                     </div> */}
  //         </div>
  //       </div>
  //     </>
  //   );
};

export default Index;
